import type { TenantPlan, TenantStatus } from "./types";

/**
 * 套餐静态展示兜底（主题色等）。数值型字段由 GET /api/platform/plan-templates 覆盖；
 * 平台端请使用 usePlanTemplatesMerged() 将二者合并后再展示。
 */
export const planConfig: Record<
  TenantPlan,
  {
    label: string;
    color: string;
    bgColor: string;
    price: number;
    maxMembers: number;
    maxAdmins: number;
    storage: number;
    features: string[];
  }
> = {
  trial: {
    label: "试用版",
    color: "text-gray-600",
    bgColor: "bg-gray-100",
    price: 0,
    maxMembers: 100,
    maxAdmins: 1,
    storage: 100,
    features: ["会员管理", "基础活动", "数据总览"],
  },
  basic: {
    label: "基础版",
    color: "text-green-700",
    bgColor: "bg-green-50",
    price: 1980,
    maxMembers: 1000,
    maxAdmins: 3,
    storage: 500,
    features: ["会员管理", "内容发布", "活动管理", "数据总览", "消息通知"],
  },
  standard: {
    label: "标准版",
    color: "text-amber-700",
    bgColor: "bg-amber-50",
    price: 4980,
    maxMembers: 5000,
    maxAdmins: 10,
    storage: 2000,
    features: ["会员管理", "内容发布", "活动管理", "投票管理", "消息通知", "数据报表", "系统设置"],
  },
  premium: {
    label: "旗舰版",
    color: "text-red-700",
    bgColor: "bg-red-50",
    price: 12800,
    maxMembers: 999999,
    maxAdmins: 999,
    storage: 10000,
    features: ["全部功能", "无限会员", "专属客服", "定制开发", "API接入", "多端支持"],
  },
};

export const statusConfig: Record<TenantStatus, { label: string; color: string; dot: string }> = {
  active: { label: "运营中", color: "text-green-700 bg-green-50", dot: "bg-green-500" },
  pending: { label: "待激活", color: "text-amber-700 bg-amber-50", dot: "bg-amber-500" },
  suspended: { label: "已停用", color: "text-gray-500 bg-gray-100", dot: "bg-gray-400" },
  expired: { label: "已过期", color: "text-red-600 bg-red-50", dot: "bg-red-400" },
};
